/* ===========================================================
   키즈다 뉴스 — 카테고리 목록 API (categoryList)
   codeType: "TYPES", type: "NEWS"
   =========================================================== */
import graphqlClient from "../../utils/graphql_client_util";

const CATEGORY_LIST_QUERY = `
  query CategoryList($input: CategorySearchInput!) {
    categoryList(input: $input) {
      totalPages
      totalElements
      success
      size
      page
      error {
        code
        errorType
        message
      }
      data {
        type
        title
        order
        color
        files {
          s3key
        }
        categorySeq
      }
    }
  }
`;

/**
 * ARGB/RGB hex 문자열(예: "FFFF7520")을 CSS hex("#FF7520")로 변환
 */
function toCssColor(raw) {
  if (!raw || typeof raw !== "string") return "#155dfc";
  const hex = raw.replace(/[^0-9a-fA-F]/g, "");
  const rgb = hex.length >= 8 ? hex.slice(-6) : hex.length === 6 ? hex : null;
  return rgb ? `#${rgb}` : "#155dfc";
}

/**
 * 뉴스 카테고리 목록 조회 → 메뉴 컴포넌트용 형태로 변환
 * 반환: [{ key, name, color, order, image }] (order 오름차순) | null(실패)
 */
export const getNewsCategoryList = async () => {
  try {
    const data = await graphqlClient.query(
      CATEGORY_LIST_QUERY,
      { input: { codeType: "TYPES", type: "NEWS" } },
      { useAuth: false }
    );

    const res = data?.categoryList;
    if (res?.success && Array.isArray(res.data) && res.data.length) {
      return [...res.data]
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .map((c) => ({
          key: String(c.categorySeq),
          name: c.title,
          color: toCssColor(c.color),
          order: c.order,
          image: c.files?.[0]?.s3key || null,
        }));
    }
    return null;
  } catch (err) {
    console.error("getNewsCategoryList error:", err);
    return null;
  }
};
